import React from 'react';

const ReferralReasonsSection = ({ selectedReasons, onChange, error }) => {
  const reasonOptions = [
    { 
      value: 'pulpite_irreversible', 
      label: 'Pulpite irréversible',
      description: 'Inflammation pulpaire nécessitant un traitement'
    },
    { 
      value: 'necrose_pulpaire', 
      label: 'Nécrose pulpaire',
      description: 'Mort du tissu pulpaire'
    },
    { 
      value: 'reprise_traitement', 
      label: 'Reprise de traitement',
      description: 'Traitement antérieur nécessitant révision'
    },
    { 
      value: 'lesion_periapicale', 
      label: 'Lésion péri-apicale',
      description: 'Infection à l\'apex de la racine'
    },
    { 
      value: 'felure_fracture', 
      label: 'Fêlure / fracture suspectée',
      description: 'Fracture dentaire ou dent fêlée'
    },
    { 
      value: 'diagnostic_douleur', 
      label: 'Diagnostic de douleur',
      description: 'Douleur complexe nécessitant évaluation'
    },
    { 
      value: 'autre', 
      label: 'Autre',
      description: 'Autre indication clinique'
    }
  ];

  const handleCheckboxChange = (value) => {
    const newReasons = selectedReasons?.includes(value)
      ? selectedReasons?.filter(r => r !== value)
      : [...selectedReasons, value];
    onChange(newReasons);
  };

  return (
    <div className="glass-card rounded-2xl p-6 hover-glow hover-lift">
      <div className="mb-5">
        <h2 className="text-lg font-semibold text-white mb-1">
          Motif(s) d'adressage
        </h2>
        <p className="text-sm text-gray-400">
          Sélectionnez toutes les indications applicables
        </p>
      </div>
      <div className="space-y-3">
        {reasonOptions?.map((option) => (
          <label
            key={option?.value}
            className="flex items-start gap-3 p-4 rounded-xl bg-white/5 border border-white/10 hover:border-primary/40 hover:bg-white/8 hover:shadow-[0_0_20px_rgba(74,144,226,0.1)] transition-all cursor-pointer"
          >
            <input
              type="checkbox"
              checked={selectedReasons?.includes(option?.value)}
              onChange={() => handleCheckboxChange(option?.value)}
              className="mt-0.5 w-4 h-4 rounded border-white/30 bg-white/10 text-primary focus:ring-2 focus:ring-primary/50 transition-all"
            />
            <div className="flex-1">
              <div className="text-sm font-medium text-white">{option?.label}</div>
              <div className="text-xs text-gray-400 mt-1">{option?.description}</div>
            </div>
          </label>
        ))}
      </div>
      {error && (
        <p className="text-sm text-red-400 mt-3">{error}</p>
      )}
    </div>
  );
};

export default ReferralReasonsSection;